import { render, staticRenderFns } from "./FilterBarStatistics.vue?vue&type=template&id=4484e2d7"
import script from "./FilterBarStatistics.vue?vue&type=script&lang=js"
export * from "./FilterBarStatistics.vue?vue&type=script&lang=js"
import style0 from "./FilterBarStatistics.vue?vue&type=style&index=0&id=4484e2d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports